module.exports = __webpack_public_path__ + "img/p112.ae645733.jpg";